import { Box, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { ComplianceRejectedEvent, DetectionEvent } from '../../../../../../../../../../../../../generated/core-api/graphql-react-query';

interface RejectedEventItemProps {
  sessionEvent: ComplianceRejectedEvent;
}

export default function RejectedEventItem(props: RejectedEventItemProps) {
  const { sessionEvent } = props;
  const { t } = useTranslation('session-event');

  const commands = sessionEvent.causes
    .filter((cause) => cause.event.__typename === 'DetectionEvent')
    .map((cause) => cause.event as DetectionEvent)
    .map((cause) => cause.trigger?.text);
  const verbatim = sessionEvent.causes.filter((cause) => cause.event.__typename === 'DetectionEvent')
    .map((cause) => cause.event as DetectionEvent)
    .map((cause) => cause.ASRText);

  if (!commands.length) {
    return null;
  }

  return (
    <Box>
      <Typography variant="body1">
        <Trans
          t={t}
          i18nKey="compliance-required.rejected"
          components={{ 1: <strong /> }}
          values={{
            command: commands.join(', '),
          }}
        />
      </Typography>
      <Typography variant="body2">
        {verbatim.join(', ')}
      </Typography>
    </Box>
  );
}
